<template>
  <div :id="'comment-' + id" class="comment">
    <section class="box" :class="{ 'is-active' : active }" >

      <div>
        <div class="content">
        <div class="user-container">
          <section class="comment-header mb-1">
            <section class="timestamp-section">
              <a class="tag is-primary play-tag no-select" @click="jumpToTime()" >
              <PlayIcon />

              {{ prettyTimeStamp(start_time, end_time) }}</a>
            </section>
            <section class="user-name-container mt-1">
              <section class="user-name-section">
                <img :src="user.avatar_url" class="image is-32x32 mr-1 rounded">
                <strong>{{ user.name || user.email }}</strong>
              </section>

              <UpdatingTime :time="created_on" class="text-muted"/>
            </section>
            <div class="time-picker-container" v-if="editing">
              <span class="my-input-container">
                <input
                  v-model="startTimeMins"
                  placeholder="01"
                  type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
              </span>
              <span class="my-time-divider">:</span>
              <span class="my-input-container">
                <input
                  v-model="startTimeSecs"
                  placeholder="21"
                  type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
              </span>

              <div class="time-divider"></div>

              <span class="my-input-container">
                <input
                  v-model="endTimeMins"
                  placeholder="09"
                  type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
              </span>
              <span class="my-time-divider">:</span>
              <span class="my-input-container">
               <input
                v-model="endTimeSecs"
                placeholder="57"
                type="text" class="my-input text" value="" size="2" maxlength="2" tabindex="0" />
              </span>
            </div>

          </section>
        </div>
          <p v-if="!editing" class="white-space-pre">{{ body }}</p>
          <textarea
            @keydown.esc="editing = false"
            @keydown.shift.enter="updateComment()"
            v-if="editing"
            v-textautosize
            v-select
            class="textarea"
            placeholder="Add a comment..."
            ref="body"
            :value="body"/>


          <section class="tags">
            <Tag v-for="tag in tags"
              :key='tag.id'
              :id='tag.id'
              :rubric='tag.rubric'
              :color='tag.color'
              :title='tag.title'
              :videoID='videoID'
              :commentID='id'
              :editing='editing'
              :score="getScore(tag.id)"
              :scoreID="getScoreID(tag.id)"
              :owner="tag.user == user"
              :groupTag="tag.group_tag"
            />
            <!-- <span v-if="editing" @click="toggleAddRubricTagModal()" class="button is-small rubric-tag">+ rubric</span> -->
          </section>

          <div class="button-container">

              <a v-if="!editing" class="no-select" @click="toggleReplytoComment(cycleID, videoID, id)">Reply</a>

              <span>
                <button
                  v-if="editing"
                  @click="updateComment()"
                  type='button'
                  :class="updating && 'is-loading'"
                  class='button is-small is-info'>
                  Save
                </button>
                <button
                  v-if="editing"
                  @click="toggleAddTagModal()"
                  class="button is-small is-warning">
                  + Tag
                </button>
              </span>

              <span>
                <button
                  v-if="editing"
                  @click="deleteComment()"
                  :class="deleting && 'is-loading'"
                  type='button'
                  class='button is-small is-danger'>
                  Delete
                </button>
                <input
                 v-if="editing"
                 @click="editComment()"
                 type='button'
                 class='button is-small '
                 value='Cancel' />
               </span>
              <a v-if="!editing && user.id == userID" @click="editComment()">Edit</a>

          </div>
        </div>

        <div v-if="replies_editing" class="">
          <article>
            <div class="content">

              <div v-if="replies_editing" class="reply-container">
                <article class="media reply">
                  <div class="media-content">
                    <div class="content">
                      <section class="user-name-container">
                        <div class="user-name-section">
                          <p class="image is-32x32 mr-1">
                            <img :src="replyUser.avatar_url">
                          </p>
                          <strong>{{ replyUser.name || replyUser.email}}</strong>
                        </div>
                      </section>
                      <textarea
                        v-if="replies_editing"
                        v-textautosize
                        v-select
                        class="textarea reply-textarea"
                        placeholder="Add a reply..."
                        v-model="replyText"
                        />
                      <div class="button-container mt-2">

                        <button
                          class='button is-small is-primary'
                          @click="addReply(cycleID, videoID, id)"
                          :disabled="!replyText"
                          :data-balloon="!replyText && 'Write a reply before submiting'"
                          data-balloon-pos="right"
                          :class="addingReply && 'is-loading'">
                            Save
                        </button>
                        <input
                          type='button'
                          class='button is-link is-small'
                          @click="toggleReplytoComment(cycleID, videoID, id)"
                          value='Cancel' />

                      </div>
                    </div>
                    </div>
                </article>
              </div>

            </div>
          </article>
        </div>

        <div class="reply-container">
          <Reply v-for="reply in replies"
            :key = 'reply.id'
            :id = 'reply.id'
            :body = 'reply.body'
            :cycleID = 'cycleID'
            :videoID = 'videoID'
            :commentID = 'id'
            :editable = 'reply.user.id == replyUser.id'
            :name = 'reply.user.name || reply.user.email'
            :avatar_url = 'reply.user.avatar_url'
            :created_on = 'reply.created_on'
          />
        </div>

      </div>
    </section>

    <AddTagModal
      @close="showAddTagModal = false"
      :show="showAddTagModal"
      :videoID="videoID"
      :commentID="id"
     />

    <AddRubricTagModal
      @close="showAddRubricTagModal = !showAddRubricTagModal"
      :show="showAddRubricTagModal"
      :commentID="id"
      :cycleID = 'cycleID'
      :videoID = 'videoID'
    />
  </div>
</template>

<script>
import store from '../store'

import Reply from './Reply.vue'
import PlayIcon from './PlayIcon.vue'
import AddRubricTagModal from './AddRubricTagModal.vue'
import Tag from './Tag.vue'
import AddTagModal from './AddTagModal.vue'
import UpdatingTime from './UpdatingTime.vue'

import { prettyTimeStamp, prettyDate } from '../filters.js'

import { textautosize, select } from '../directives.js'

import { minsSecondsToSeconds, secsToMinsandSecs } from '../time.js'

export default {
  name: 'Comment',
  props: {
    elements: {
      type: Array,
      required: false,
    },
    cycleID: {
      type: Number,
      required: false,
    },
    videoID: {
      type: Number,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    replies: {
      type: Array,
      required: true,
    },
    replies_editing: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
    created_on: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    start_time: {
      required: true,
    },
    end_time: {
      required: true,
    },
    userID: {
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
    scores: {
      type: Array,
      required: true,
    },
  },
  components: {
    Reply,
    PlayIcon,
    AddRubricTagModal,
    Tag,
    UpdatingTime,
    AddTagModal,
  },
  filters: {
    prettyDate,
  },
  directives: {
    textautosize,
    select,
  },
  data () {
    return {
      editing: false,
      showAddRubricTagModal: false,
      showAddTagModal: false,
      endTimeMins: '',
      endTimeSecs: '',
      startTimeMins: '',
      startTimeSecs: '',
      replyText: '',
      deleting: false,
      updating: false,
    }
  },
  computed: {
    addingReply () {
      return store.state.addingReply
    },
    replyUser () {
      return store.state.user
    },
  },
  methods: {
    tagClick () {
      console.log('tag click')
    },
    toggleAddRubricTagModal () {
      this.showAddRubricTagModal = !this.showAddRubricTagModal
    },
    toggleAddTagModal () {
      this.updateComment()
      this.showAddTagModal = !this.showAddTagModal
    },
    jumpToTime () {
      const { cycleID, videoID, id } = this
      store.commit('setCommentToActive', { cycleID, videoID, commentID: id })
      // TODO: we should add an ID and reference that instead, since there may
      // be more videos in the future
      const video = document.querySelector('video')
      video.currentTime = this.start_time
      video.play()

      // setTimeout(() => {
      //   video.pause()
      // }, this.end_time * 1000)

      // const progressEventHandler = e => {
      //   const currentTime = document.querySelector('video').currentTime
      //   if (currentTime >= this.end_time || currentTime < this.start_time) {
      //     video.removeEventListener('timeupdate', progressEventHandler)
      //     video.pause()
      //   }
      // }
      // video.removeEventListener('timeupdate', progressEventHandler)
      // video.addEventListener('timeupdate', progressEventHandler)
    },
    prettyTimeStamp,
    addReply (cycleID, videoID, commentID) {
      const text = this.replyText
      store.dispatch('addReply', {
        cycleID,
        videoID,
        commentID,
        text,
      })
      .then(() => {
        this.replyText = ''
      })
    },
    toggleReplytoComment (cycleID, videoID, commentID) {
      store.commit('toggleReplytoComment', {
        cycleID,
        videoID,
        commentID,
      })
    },
    async updateComment () {
      const {
        cycleID,
        videoID,
        id,
        endTimeMins,
        endTimeSecs,
        startTimeMins,
        startTimeSecs,
      } = this

      const body = this.$refs.body.value
      const endTime = minsSecondsToSeconds([endTimeMins, endTimeSecs])
      const startTime = minsSecondsToSeconds([startTimeMins, startTimeSecs])

      this.updating = true
      await store.dispatch('updateComment', {
        cycleID,
        videoID,
        commentID: id,
        body,
        start_time: startTime,
        end_time: endTime,
      })
      this.updating = false
      this.editing = false
    },
    editComment () {
      // we need to set the default values of the inputs to the default values of the current inputs.

      const [ endMins, endSecs ] = secsToMinsandSecs(this.end_time)
      const [ startMins, startSecs ] = secsToMinsandSecs(this.start_time)

      this.endTimeMins = endMins
      this.endTimeSecs = endSecs
      this.startTimeMins = startMins
      this.startTimeSecs = startSecs

      this.editing = !this.editing

      const len = this.body.length
      this.$nextTick(() => {
        this.$refs.body.focus()
        this.$refs.body.setSelectionRange(len, len)
      })
    },
    deleteComment () {
      const { cycleID, videoID, id } = this
      this.deleting = true
      store.dispatch('deleteComment', {
        cycleID,
        videoID,
        commentID: id,
      })
      .then(() => {
        this.deleting = false
      })
    },
    getScore (tagID) {
      for (const score of this.scores) {
        if (score.tag === tagID) {
          return score.value
        }
      }
      return null
    },
    getScoreID (tagID) {
      for (const score of this.scores) {
        if (score.tag === tagID) {
          return score.id
        }
      }
      return null
    }
  },
}
</script>

<style lang="scss" scoped>
// setup the outline of the comment so when a user clicks the play button, it
// is selected
@import '../_variables.scss';

.comment {
  margin: 3px;

  outline-color: transparent;
  transition: outline-color 0.2s;
}

.user-name-section {
  display: flex;
  align-items: center;
}

.play-tag {
  font-size: 1rem;
}

.user-name-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.editting-comments-container > a {
  margin-left: 1.5rem;
}

.time-picker-container {
  display: flex;
  align-items: center;
  margin-bottom: .75rem;
}

.comment-header {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.timestamp-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.reply-buttons {
  margin-top: .75rem;
  margin-bottom: .75rem;
}

// Bulma override so comments aren't space weird
.content:not(:last-child) {
  margin-bottom: 0;
}

.content p:not(:last-child) {
  margin-bottom: 0.25rem;
}

.time-divider {
  width: 1rem;
  height: 3px;
  border-radius: $radius-large;
  background-color: gray;
  margin: 5px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reply-container {
  margin-left: 10px;
  border-left: 3px #dbdbdb solid;
  padding-left: 5px;
}


.reply-user-name-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
}



.my-input {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
}

.tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}


@import '../_variables.scss';

.button.rubric-tag {
  background-color: rgb(229, 0, 233);
  border-radius: 3px;
  color: whitesmoke;
  font-weight: bold;
  text-shadow: $nice-gray 1px 1px 6px;
  margin-top: .75rem;
  margin-bottom: .75rem;
}


.reply-container {
  margin-left: 10px;
  border-left: 3px #dbdbdb solid;
  padding-left: 5px;
}

// added to a new comment
.new {
  animation: new 1.5s;
  outline-style: solid;

  @keyframes new {
    0% {
      opacity: 1;
      outline-color: transparent;
    }
    50% {
      opacity: 0.5;
      outline-color: $teal;
    }
    100% {
      opacity: 1;
      outline-color: transparent;
    }
  }
}

.no-select {
  user-select: none;
}

.white-space-pre {
  white-space: pre-wrap;
}

.textarea {
  margin-bottom: .5rem;
}

</style>



// WEBPACK FOOTER //
// Comment.vue?36564e7e